'use client';
import e$1 from 'prop-types';
import * as e from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { deprecatedPropValues } from '../core/deprecated-prop-values.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, n, r) {
    return n in e ? Object.defineProperty(e, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[n] = r, e;
}
function _object_spread(e) {
    for(var n = 1; n < arguments.length; n++){
        var r = null != arguments[n] ? arguments[n] : {}, t = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), t.forEach(function(n) {
            _define_property(e, n, r[n]);
        });
    }
    return e;
}
let i = {
    accessibleText: e$1.string.isRequired,
    size: deprecatedPropValues(e$1.oneOf([
        'super',
        'standard',
        'mini',
        'tiny'
    ]), [
        'mini',
        'tiny'
    ], 'Use standard size instead'),
    layout: e$1.oneOf([
        'vertical',
        'horizontal'
    ]),
    showText: e$1.bool,
    overlay: e$1.bool
}, p = Object.keys(i);
const Spinner = renderWithRef('Spinner', i, (e$1, r)=>{
    useComponentStylesLoaded('Spinner', SWAN_STYLE_KEY_MAP.spinner);
    let { size: a = 'standard', accessibleText: i, layout: c = 'vertical', showText: l = !1, overlay: d = !1 } = e$1, m = new Set([]);
    return m.add('swan-spinner'), 'standard' !== a && m.add(`swan-spinner-${a}`), 'horizontal' === c && m.add("swan-spinner-horizontal"), l && m.add("swan-spinner-show-text"), d && m.add("swan-spinner-overlay"), e.createElement(RenderComp, {
        root: "span",
        forwardedRef: r,
        propKeysToRemove: p,
        classNames: m,
        props: _object_spread({}, e$1)
    }, e.createElement("span", {
        className: "swan-spinner-animation"
    }, e.createElement("span", {
        className: "swan-spinner-animation-inner"
    })), e.createElement("span", {
        className: "swan-spinner-text"
    }, i));
});

export { Spinner };
